import { dateToYmd } from "./bookingStepperUtils";

// "YYYY-MM-DD" + "HH:mm" of the moment the vendor is in. The server sends its own wall clock
// (vendor_time_slots.now_local) so a staff device in another zone cannot skew it; the browser's
// clock is only a fallback for an older server.
const vendorNow = (data, fallback = new Date()) => {
  const m = String(data?.now_local || "").match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/);
  if (m) return { date: m[1], time: m[2] };
  const hh = String(fallback.getHours()).padStart(2, "0");
  const mm = String(fallback.getMinutes()).padStart(2, "0");
  return { date: dateToYmd(fallback), time: `${hh}:${mm}` };
};

/**
 * The slot to pre-select in the Optional-provider time list, as "HH:MM" ("" = nothing to pick).
 *   today          the first slot at or after the current time; once the day is over (after
 *                  hours) the last slot of the day
 *   any other day  the first slot of the day (a past day is a backfill, a future day starts early)
 * A fully booked slot is still a valid pick - the screen shows its "already booked" note - but a
 * slot the job would run past closing time for ("after_hours") is never offered.
 */
export function pickNearestSlot(data, fallbackNow = new Date()) {
  if (!data || data.closed) return "";
  const usable = (data.slots || []).filter((s) => s?.time && s.status !== "after_hours");
  if (!usable.length) return "";
  const now = vendorNow(data, fallbackNow);
  if (data.date !== now.date) return usable[0].time;
  const upcoming = usable.find((s) => s.time >= now.time);
  return (upcoming || usable[usable.length - 1]).time;
}
